import { getSelectedLanguage } from '@frontend/translate';
import type { OutpatientClinicCategory } from '../types/outpatientClinicCategory';

export function translateOutpatientClinicCategory(category: OutpatientClinicCategory): string {
    const translate = getSelectedLanguage();

    return translate.outpatientClinic.tasks.categoryName[category];
}
